import React from 'react';
import { useTranslation } from 'react-i18next';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import PlaylistReport from '../../../../components/PlaylistReport';
import { useOktaQuery, Playlists } from '../../../../data';

const TeamPlaylists = ({ match: { params: { teamId } } }) => {
    const { t: translate } = useTranslation();
    const { PlayerID } = usePlayerSelector();
    const { data: playlists, isLoading } = useOktaQuery(['playlist-team', PlayerID, teamId], (t) => Playlists.getTeamPlaylist(t, PlayerID, teamId));

    return <PlaylistReport title={translate('sections.opponent.team.team-playlists')} isLoading={isLoading} playlists={playlists} />;
};

export default TeamPlaylists;
